import {useOnlinePing} from '@hooks/useOnlinePing';

export const OnlinePingTracker = (): null => {
    useOnlinePing();

    return null;
};
